import React from 'react';
import LoadingSpinnerView from '../../../../Common/Components/LoadingSpinnerView.jsx';
import RateCardTable from '../../../Common/Components/RateCardTable.jsx'

export default function SingleRateCardView({ rateCard }) {
    function getInnerComponent(rateCard) {
        switch(rateCard) {
            case undefined:
                return <LoadingSpinnerView />;
            case null:
                return <RateCardNotFoundView />;
            default:
                return <RateCardDetailView rateCard={ rateCard } />;
        }
    }

    return <section className="segment"><h2>Rate card</h2>{ getInnerComponent(rateCard) }</section>;
}

function RateCardNotFoundView() {
    return <p>Rate card not found.</p>;
}

function RateCardDetailView({ rateCard }) {
    return <RateCardTable rateCards={ [rateCard] } expanded={ { 0: true } } showPagination={ false } />;
}
